import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-solutions',
  templateUrl: './home-solutions.component.html',
  styleUrls: ['./home-solutions.component.css']
})
export class HomeSolutionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
